import {
  FormControl,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Spacer,
  Stack,
} from '@chakra-ui/react';
import * as React from 'react';
import { SelectDropdown } from '@/components/SelectDropdown';
import { EAttribute_InputType } from '@/graphql-types/globalTypes';
import { Filter } from '@/hooks/useFilterableAttributes';
import { SearchIcon, XIcon } from '@/imports/ui/chakra/feather';

export const MemberDirectorySelectedFilters: React.FC<{
  selectedFilters: Filter[];
  unselectFilter: (params: { attributeSchemaId: string }) => void;
  selectFilter: (params: { attributeSchemaId: string; facet?: string }) => void;
  freeTextValues: Record<string, string>;
  onFreeTextValueChange: (attributeSchemaId: string, value: string) => void;
}> = ({
  selectedFilters,
  unselectFilter,
  selectFilter,
  freeTextValues,
  onFreeTextValueChange,
}) => {
  if (!selectedFilters.length) {
    return null;
  }

  return (
    <>
      {selectedFilters.map((filter) => {
        const isFreeText =
          filter.attributeSchema.inputType === EAttribute_InputType.FREE_TEXT;

        return (
          <FormControl
            key={filter.attributeSchema._id}
            display="flex"
            flexDirection="column"
          >
            <Stack direction="row" mb="2">
              <FormLabel textTransform="uppercase" m="0" flex="1">
                {filter.attributeSchema.name}
              </FormLabel>
              <IconButton
                aria-label="remove filter"
                icon={<XIcon color="primary.500" boxSize="5" />}
                size="xs"
                variant="ghost"
                colorScheme="primary"
                onClick={() =>
                  unselectFilter({
                    attributeSchemaId: filter.attributeSchema._id,
                  })
                }
              />
            </Stack>

            <Spacer />

            {isFreeText ? (
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <SearchIcon color="primary.500" />
                </InputLeftElement>
                <Input
                  variant="outline"
                  borderRadius="md"
                  placeholder={`Search By ${filter.attributeSchema.name}`}
                  type="search"
                  value={freeTextValues[filter.attributeSchema._id] ?? ''}
                  onChange={(event) =>
                    onFreeTextValueChange(
                      filter.attributeSchema._id,
                      event.target.value
                    )
                  }
                />
              </InputGroup>
            ) : (
              <SelectDropdown selectFilter={selectFilter} filter={filter} />
            )}
          </FormControl>
        );
      })}
    </>
  );
};
